<page-title text="BitOasis | Buy, Sell and trade Bitcoin, Ether, XRP, Bitcoin Cash and more securely and conveniently" i18n-text="@@pageTitle.home"></page-title>

<site-header></site-header>
<div class="header">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="header-content">
          <h1 class="large" i18n="@@front.home.header.title">Buy Bitcoin & 60+ Crypto</h1>
          <ng-container *ngIf="promotion?.promotionEnabled">
            <h2 class="text-subtitle" i18n="@@front.home.header.promotion.subtitle">Signup Now & Get {{promotion?.reward?.amount}} {{promotion?.reward?.currency}}</h2>
          </ng-container>
          <ng-container *ngIf="promotion?.promotionEnabled === false">
            <h2 class="text-subtitle" i18n="@@front.home.header.subtitle">Get started in minutes</h2>
          </ng-container>
          <ng-container *ngIf="!promotion?.promotionEnabled">
            <h2 class="text-subtitle">&nbsp;</h2>
          </ng-container>

          <div class="header-spacer"></div>
          <p class="text" i18n="@@front.home.header.join">Join 1M+ customers buying and selling 60+ cryptocurrencies in the Middle East</p>
          <get-started *ngIf="!isLoggedIn()" class="getstarted d-none d-lg-block"></get-started>
          <div class="header-spacer"></div>
          <div class="stores">
            <a href="https://apple.co/31XHi3T" target="_blank" rel="noopener">
              <img src="assets/images/mobile-stores/{{currentLanguage}}/apple-app-store.svg" alt="Apple App Store">
            </a>
            <div class="p-2"></div>
            <a href="https://play.google.com/store/apps/details?id=com.bitoasis&hl={{currentLanguage}}" target="_blank" rel="noopener">
              <img src="assets/images/mobile-stores/{{currentLanguage}}/google-play-store.svg" alt="Google Play Store">
            </a>
          </div>
        </div>
      </div><!-- .content-container -->
      <div class="col-lg-4 d-none d-lg-block">
        <div class="hero">
          <div class="video-mask">
            <video #heroVideo *ngIf="!isMobile" id="hero-video" autoplay muted loop>
              <source src="assets/images/home/hero-{{currentLanguage}}.webm" type="video/webm">
              <source src="assets/images/home/hero-{{currentLanguage}}.mp4" type="video/mp4">
            </video>
          </div>
        </div>
      </div><!-- .hero-container -->
    </div>
  </div><!-- .container -->
</div><!-- .header -->

<section class="prices container">
  <div class="live">
    <div class="circle"></div>
    <div class="spacer"></div>
    <div class="main-text" i18n="@@front.home.prices.live">Live</div>
    <div class="spacer"></div>
    <div *ngIf="lastUpdate" class="text-gray"><ng-container i18n="@@front.home.prices.lastUpdated">Prices Last updated:</ng-container> {{lastUpdate | date:'medium'}}</div>
  </div>
  <div class="prices-wrapper">
    <crypto-prices [count]="5" [showHeader]="false" [showUpdateDate]="false" (update)="onPricesUpdate($event)"></crypto-prices>
  </div>
  <div class="text-center">
    <a routerLink="/prices" class="more">
      <div i18n="@@front.home.prices.more">Show all 60+ crypto assets</div>
      <div class="p-1"></div>
      <span class="icon-chevron-right"></span>
    </a>
  </div>
</section>

<div class="section-spacer"></div>

<section class="section">
  <start-steps></start-steps>
  <div class="p-2"></div>
  <a *ngIf="!isLoggedIn()" href="/register" class="btn btn-primary btn-wide" i18n="@@front.home.getStarted.getStartedButton">Get Started</a>
  <a *ngIf="isLoggedIn()" href="/dashboard" class="btn btn-primary btn-wide" i18n="@@front.home.getStarted.dashboardButton">Dashboard</a>
</section>

<div class="section-spacer"></div>

<section class="section features">
  <div class="container">
    <bitoasis-features></bitoasis-features>
  </div>
</section>

<div class="section-spacer"></div>

<section class="section products">
  <h3 class="text-xxl text-center text-bold" i18n="@@front.home.products.title">Our Products and Services</h3>
  <p class="text-center text-gray" i18n="@@front.home.products.subtitle">BitOasis gives you access to easy-to-use investment and trading tools</p>
  <div class="p-4"></div>

  <div class="container">
    <div class="product-invest row g-0 align-items-center">
      <div class="col-lg-6 text-end">
        <div class="img">
          <img src="assets/images/home/bitoasis-core.jpg" alt="BitOasis Lite">
        </div>
      </div><!-- .col-lg-6 -->
      <div class="col-lg-1"></div>
      <div class="col-lg-4">
        <h4 class="text-xxl text-bold" i18n="@@front.home.products.broker.title">BitOasis Lite</h4>
        <p i18n="@@front.home.products.broker.description">Buy, sell and trade in <b>60+ digital assets</b> with <b>0% commission fees</b></p>
        <p i18n="@@front.home.products.broker.description2">Manage and track your portfolio on the go from your <b>laptop</b> or <b>mobile</b>.</p>
        
        <div class="d-flex text-right pt-3">
          <a routerLink="/page/lite" class="col btn btn-front btn-outline"
            i18n="@@front.home.products.broker.more">Learn more</a>
          <div class="p-2"></div>
          <a [routerLink]="isLoggedIn() ? ['/lite'] : ['/register']" class="col btn btn-front btn-primary"
            i18n="@@front.home.products.broker.actionButton">Start Now</a>
        </div>
      </div><!-- .col-lg-4 -->
      <div class="col-lg-1"></div>
    </div><!-- .product-invest -->
  </div><!-- .container -->

  <div class="product-spacer"></div>

  <div class="container">
    <div class="product-trade row g-0 align-items-center">
      <div class="col-lg-1"></div>
      <div class="col-lg-4 order-2 order-lg-1">
        <h4 class="text-xxl text-bold" i18n="@@front.home.products.exchange.title">BitOasis Pro</h4>
        <p i18n="@@front.home.products.exchange.description">Trade <b>60+ digital assets</b> and <b>fiat pairs</b> in real time with sophisticated <b>trading charts</b> & <b>order types</b>.</p>
        
        <div class="d-flex text-right pt-3">
          <a routerLink="/page/pro" class="col btn btn-front btn-outline"
            i18n="@@front.home.products.exchange.more">Learn more</a>
          <div class="p-2"></div>
          <a [routerLink]="isLoggedIn() ? ['/pro'] : ['/register']" class="col btn btn-front btn-primary"
            i18n="@@front.home.products.exchange.actionButton">Trade Now</a>
        </div>
      </div><!-- .col-lg-4 -->
      <div class="col-lg-1 order-lg-2"></div>
      <div class="col-lg-6 order-1 order-lg-3 text-end">
        <div class="img">
          <img src="assets/images/home/bitoasis-pro.jpg" alt="BitOasis Pro">
        </div>
      </div><!-- .col-lg-6 -->
    </div><!-- .product-trade -->
  </div>

  <div class="product-spacer"></div>

  <div class="container">
    <div class="product-data">
      <div class="row align-items-center h-100">
        <div class="col-lg-8 h-100">
          <div class="content h-100">
            <p class="mb-2" i18n="@@front.home.products.data1">BitOasis in numbers</p>
            <h4 class="text-primary text-bold text-xl mb-2" i18n="@@front.home.products.data2">Over USD 3 billion in trade volume in 2021</h4>
            <p class="mb-0" i18n="@@front.home.products.data3">More than 500,000 active customers use BitOasis in 14 countries across MENA</p>
          </div>
        </div><!-- .content-container -->
        <div class="col-lg-3 d-none d-lg-block h-100">
          <div class="img">
            <img src="assets/images/home/mobiles.png" alt="">
          </div>
        </div><!-- .img-container -->
        <div class="col-lg-1 d-none d-lg-block"></div>
      </div>
    </div>
  </div><!-- .container -->
</section><!-- .products-->

<div class="section-spacer"></div>

<section class="section blog">
  <div class="container">
    <h3 class="text-center text-xxl text-bold"><a [href]="links?.blog" target="_blank" rel="noopener" i18n="@@front.home.blog.title">Recent Blog Post</a></h3>
    <p class="text-center" i18n="@@front.home.blog.description">News and updates from our team</p>
    <div class="p-3"></div>

    <blog-posts></blog-posts>
  </div>
</section>

<section class="section press">
  <div class="container">
    <div class="press-list">
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/forbes-logo.svg" alt="Forbs"></a>
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/coindesk-logo.svg" alt="CoinDesk"></a>
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/gulf-news-logo.svg" alt="Gulf News"></a>
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/tech-crunch-logo.svg" alt="Tech Crunch"></a>
      <div class="w-100"></div>
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/arabian-business-logo.svg" alt="Arabian Business"></a>
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/wamda-logo.svg" alt="Wamda"></a>
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/fast-company-logo.svg" alt="Fast Company"></a>
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/bloomberg-logo.svg" alt="Bloomberg"></a>
      <a href="javascript: void(0);" rel="noopener"><img src="assets/images/press/cointelegraph-logo.svg" alt="CoinTelegraph"></a>

    </div>
  </div>
</section>

<site-footer></site-footer>